import { CoupanItem } from "../screens/CoupansScreen/CoupanScreenStore";


function getCsrfToken(): string | null {
    const meta = document.querySelector('meta[name="csrf-token"]');
    console.log(meta);
    return meta ? meta.getAttribute("content") : null;
}

export async function loginProcess(email: string, password: string): Promise<any> {
    const csrf = getCsrfToken();


    // Trim values to prevent spaces-only input
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();

    // Frontend validation
    if (!trimmedEmail && !trimmedPassword) {
        window.alert("Email and Password are required.");
        return undefined;
    }

    if (!trimmedEmail) {
        window.alert("Email is required.");
        return undefined;
    }

    if (!trimmedPassword) {
        window.alert("Password is required.");
        return undefined;
    }

    try {
        const response = await fetch('/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                "X-CSRF-TOKEN": csrf || ""
            },
            credentials: 'include',
            body: JSON.stringify({ email: trimmedEmail, password: trimmedPassword })
        });

        const data = await response.json();

        if (data.user) {
            return data.user;
        } else {
            window.alert(data.error || "Login failed.");
            return undefined;
        }

    } catch (error) {
        window.alert("Something went wrong. Please try again.");
        return undefined;
    }
}

export async function sendOtp(email: string, type: string): Promise<boolean> {
    const csrf = getCsrfToken();
    const response = await fetch(`/sendOtp`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrf || ""
        },
        body: JSON.stringify({ email, type }),
    });
    const data = await response.json();
    if (data.message) {
        return true
    } else {
        window.alert(data.error);
        return false
    }
}

export async function verifyOtp(email: string, otp: string): Promise<boolean> {
    const csrf = getCsrfToken();
    const response = await fetch(`/verify-otp`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrf || ""
        },
        credentials: "include", // IMPORTANT
        body: JSON.stringify({ email, otp }),
    });
    const data = await response.json();
    if (data.message) {
        return true
    } else {
        window.alert(data.error);
        return false
    }

}

export async function handlePasswordUpdate(
    mode: "update" | "forgot",
    new_password: string,
    new_password_confirmation: string,
    current_password?: string
): Promise<boolean> {

    const csrf = getCsrfToken();
    const body: any = {
        mode,
        new_password,
        new_password_confirmation,
    };

    // Only attach current_password if mode is update
    if (mode === "update") {
        body.current_password = current_password;
    }

    const response = await fetch("/update-password", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-CSRF-TOKEN": csrf || ""
        },
        credentials: "include",
        body: JSON.stringify(body),
    });

    const data = await response.json();

    if (response.ok) {
        return true;
    } else {
        window.alert(data.error || "Something went wrong");
        return false;
    }
}

export async function buyCoupanToken(item: CoupanItem): Promise<any> {
    const csrf = getCsrfToken();
    const response = await fetch("/createIvdCoupan", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-CSRF-TOKEN": csrf || ""
        },
        credentials: "include", // important for Laravel session auth
        body: JSON.stringify({
            coupanItemId: Number(item.id),
            fordays: Number(item.fordays),
            loggedsysid: "notloggedyet",
        }),
    });
    const data = await response.json();

    if (!response.ok) {
        window.alert(`Error ${data.error}`);
        return undefined;
    }

    return data;
}

export async function getOrderToken(item: CoupanItem): Promise<any> {
    const csrf = getCsrfToken();
    const response = await fetch(`/create-order`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrf || ""
        },
        credentials: "include",
        body: JSON.stringify({
            product_id: item.id
        }),
    });

    if (!response.ok) {
        const text = await response.text();
        window.alert(`Error ${text}`);
        return undefined;
    }

    const order = await response.json();
    return order;
}

export async function verifyPayment(resp: any, item: any) {
    const csrf = getCsrfToken();

    const payload = {
        razorpay_payment_id: resp?.razorpay_payment_id,
        razorpay_order_id: resp?.razorpay_order_id,
        razorpay_signature: resp?.razorpay_signature,
        product_id: item?.id
    };

    const res = await fetch("/verifyPayment", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-CSRF-TOKEN": csrf || ""
        },
        credentials: "include",
        body: JSON.stringify(payload)
    });
    console.log(res.status);

    return await res.json();
}